import React from 'react';
import styles from './index.css';
import PropTypes from 'prop-types';
import { LazyImg } from '@ifeng/ui_pc_lazyLoad';
import { formatImage } from '@ifeng/public_method';
import ShortRelate from '../../../../components/articleContent/shortRelate';
import errorBoundary from '@ifeng/errorBoundary';
import { WxLaunchApp } from 'ThreeTerminal_mobile_dynamic';
import { callApp, getSchemeLink, getWebAppLink } from '@ifeng/callapp';
import { getUrlSecretId } from '@ifeng/container_content/common/client/utils/utils';
const isVideoShare =
    (typeof window === 'object' && window.allData && window.allData.docData && window.allData.docData.isVideoShare) ||
    false;
const smallLazyImg =
    'data:image/svg+xml;utf8,<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="342" height="342"><text x="80" y="200" fill="%23dcdcdc"></text></svg>';
const bigLazyImg =
    'data:image/svg+xml;utf8,<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="360" height="200"><text x="120" y="110" fill="%23dcdcdc"></text></svg>';

class ShortPic extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        wxLaunch: PropTypes.object,
    };

    lessThanThreeImg = wbImages => {
        return (
            <ul className={styles.wbImgBox}>
                <li className={styles.wbImgGroup}>
                    {wbImages.length === 1 ? (
                        <div className={styles.wbImgItem}>
                            <LazyImg
                                className={`${styles.wbImgItemPic} ${styles.onlyWbImgItemPic}`}
                                placeholder={bigLazyImg}
                                src={wbImages[0]
                                    .replace(/_webp/, '')
                                    .replace(/png\.webp/, 'png')
                                    .replace(/jpg\.webp/, 'jpg')}
                            />
                        </div>
                    ) : (
                        wbImages.map((item, index) => (
                            <div key={index} className={styles.wbImgItem}>
                                <div className={styles.wbImgItemBox}>
                                    <LazyImg
                                        className={styles.wbImgItemPic}
                                        placeholder={smallLazyImg}
                                        src={
                                            item.includes('.gif')
                                                ? item
                                                      .replace(/_webp/, '')
                                                      .replace(/png\.webp/, 'png')
                                                      .replace(/jpg\.webp/, 'jpg')
                                                : formatImage(
                                                      item
                                                          .replace(/_webp/, '')
                                                          .replace(/png\.webp/, 'png')
                                                          .replace(/jpg\.webp/, 'jpg'),
                                                      340,
                                                      340,
                                                  )
                                        }
                                    />
                                </div>
                            </div>
                        ))
                    )}
                </li>
            </ul>
        );
    };

    equalFourImg = wbImages => {
        const imageGroup = [];

        for (let i = 0, len = wbImages.length; i < len; i += 2) {
            imageGroup.push(wbImages.slice(i, i + 2));
        }

        return (
            <ul className={styles.wbImgBox}>
                {imageGroup.map((itemGroup, indexGroup) => (
                    <li key={indexGroup} className={styles.wbImgGroup}>
                        {itemGroup.map((item, index) => (
                            <div key={index} className={styles.wbImgItem}>
                                <div className={styles.wbImgItemBox}>
                                    <LazyImg
                                        className={styles.wbImgItemPic}
                                        placeholder={smallLazyImg}
                                        src={
                                            item.includes('.gif')
                                                ? item
                                                      .replace(/_webp/, '')
                                                      .replace(/png\.webp/, 'png')
                                                      .replace(/jpg\.webp/, 'jpg')
                                                : formatImage(
                                                      item
                                                          .replace(/_webp/, '')
                                                          .replace(/png\.webp/, 'png')
                                                          .replace(/jpg\.webp/, 'jpg'),
                                                      340,
                                                      340,
                                                  )
                                        }
                                    />
                                </div>
                            </div>
                        ))}
                    </li>
                ))}
            </ul>
        );
    };

    greaterThanFiveImg = wbImages => {
        const imageGroup = [];
        const fillIndex = 3 - (wbImages.length % 3);

        for (let j = 0; j < fillIndex; j++) {
            wbImages.push('');
        }
        for (let i = 0, len = wbImages.length; i < len; i += 3) {
            imageGroup.push(wbImages.slice(i, i + 3));
        }

        return (
            <ul className={styles.wbImgBox}>
                {imageGroup.map((itemGroup, indexGroup) => (
                    <li key={indexGroup} className={styles.wbImgGroup}>
                        {itemGroup.map((item, index) => (
                            <div key={index} className={styles.wbImgItem}>
                                {item.length > 0 && (
                                    <div className={styles.wbImgItemBox}>
                                        <LazyImg
                                            className={styles.wbImgItemPic}
                                            placeholder={smallLazyImg}
                                            src={
                                                item.includes('.gif')
                                                    ? item
                                                          .replace(/_webp/, '')
                                                          .replace(/png\.webp/, 'png')
                                                          .replace(/jpg\.webp/, 'jpg')
                                                    : formatImage(
                                                          item
                                                              .replace(/_webp/, '')
                                                              .replace(/png\.webp/, 'png')
                                                              .replace(/jpg\.webp/, 'jpg'),
                                                          340,
                                                          340,
                                                      )
                                            }
                                        />
                                    </div>
                                )}
                            </div>
                        ))}
                    </li>
                ))}
            </ul>
        );
    };

    handleCallup(id, url, isSendCount = true, isJumpQQlink = false, isCallApp = true) {
        const client = isVideoShare ? 'videoApp' : 'newsApp';
        const downloads = isVideoShare
            ? {}
            : {
                  download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1458144111741',
                  downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8802',
              };

        if (isCallApp) {
            callApp({
                client,
                docType: 'doc',
                pid: id,
                kind: 'share01',
                download: downloads.download,
                downloadAd: downloads.downloadAd,
                isCopySchemeUrl: isJumpQQlink,
            });
        }
    }

    formatTime = (time, date) => {
        const minute = 1000 * 60;
        const hour = minute * 60;
        const day = hour * 24;
        const month = day * 30;
        const year = month * 12;
        const now = new Date().getTime();
        const diffValue = now - new Date(time).getTime();

        if (diffValue < 0) {
            return '';
        }
        const yearC = diffValue / year;
        const monthC = diffValue / month;
        const weekC = diffValue / (7 * day);
        const dayC = diffValue / day;
        const hourC = diffValue / hour;
        const minC = diffValue / minute;
        let result = '';

        if (yearC > 3) {
            result = date;
        } else if (yearC > 1) {
            result = '';
        } else if (monthC >= 1) {
            result = '';
        } else if (weekC >= 1) {
            result = '';
        } else if (dayC >= 1) {
            if (dayC > 3) {
                result = '';
            }
            result = `${parseInt(dayC.toString())}天前`;
        } else if (hourC >= 1) {
            result = `${parseInt(hourC.toString())}小时前`;
        } else if (minC >= 1) {
            result = `${parseInt(minC.toString())}分钟前`;
        } else {
            result = '刚刚';
        }

        return result;
    };

    render() {
        const { content, wxLaunch } = this.props;
        const mediaUrl =
            (content.subscribe &&
                content.subscribe.cateid &&
                `https://ishare.ifeng.com/mediaShare/home/${content.subscribe.cateid}/media`) ||
            'javascript:;';
        let images = (content.style && content.style.images) || [];
        const updataTime = this.formatTime(content.updateTime);
        let relateData = {};
        const gotoUrl =
            (content.link.weburl && isVideoShare
                ? `https://ishare.ifeng.com/c/vs/${content.link.weburl.split('/').pop()}`
                : content.link.weburl) || '';

        if (content.subItem) {
            relateData = {
                type: content.subItem.type === 'phvideo' ? 'video' : 'doc',
                url:
                    (content.subItem.link && isVideoShare
                        ? `https://ishare.ifeng.com/c/vs/${content.subItem.link.weburl.split('/').pop()}`
                        : content.subItem.link.weburl) || '',
                logo: (content.subItem.subscribe && content.subItem.subscribe.logo) || '',
                sourceFrom: (content.subItem.subscribe && content.subItem.subscribe.catename) || '',
                title: content.subItem.intro || '',
                image:
                    (content.subItem.thumbnail &&
                        content.subItem.thumbnail
                            .replace(/_webp/, '')
                            .replace(/png\.webp/, 'png')
                            .replace(/jpg\.webp/, 'jpg')) ||
                    '',
                duration: (content.subItem.phvideo && content.subItem.phvideo && content.subItem.phvideo.length) || '',
            };
        }
        const _id =
            (content.link && content.link.weburl && getUrlSecretId(content.link.weburl)) || content.documentId || '';

        const schemeLink =
            wxLaunch.wxLaunchType === 'weapp'
                ? getWebAppLink({
                      docType: 'short',
                      pid: _id,
                  })
                : getSchemeLink({
                      docType: 'doc',
                      pid: _id,
                      kind: 'share01',
                  });

        return (
            <div className={styles.shortRelate} onClick={this.handleCallup.bind(this, _id, gotoUrl)}>
                <div className={styles.shortRelateHead}>
                    {content.subscribe &&
                        content.subscribe.logo && (
                            <div className={styles.shortRelateHeadImg}>
                                <div>
                                    <LazyImg
                                        className={styles.shortRelateHeadPic}
                                        placeholder="data:image/svg+xml;utf8,<svg version=&quot;1.1&quot; xmlns=&quot;http://www.w3.org/2000/svg&quot; width=&quot;64&quot; height=&quot;64&quot;><rect x=&quot;0&quot; y=&quot;0&quot; width=&quot;349&quot; height=&quot;196&quot; fill=&quot;%23f2f2f2&quot;/></svg>"
                                        src={formatImage(
                                            content.subscribe.logo
                                                .replace(/_webp/, '')
                                                .replace(/png\.webp/, 'png')
                                                .replace(/jpg\.webp/, 'jpg'),
                                            64,
                                            64,
                                        )}
                                    />
                                </div>
                            </div>
                        )}
                    <div className={styles.shortRelateHeadText}>
                        <div>
                            <div className={styles.shortRelateHeadName}>{content.source}</div>
                            <div className={styles.shortRelateHeadInfo}>
                                {updataTime && <span className={styles.shortRelateHeadTime}>{updataTime}</span>}
                                {content.subscribe &&
                                    content.subscribe.description && (
                                        <span className={styles.shortRelateHeadBref}>
                                            {content.subscribe.description}
                                        </span>
                                    )}
                            </div>
                        </div>
                    </div>
                    <div className={styles.shortRelateHeadFollow}>
                        <span className={styles.shortRelateHeadBtn}>关注</span>
                    </div>
                </div>
                <div
                    className={styles.shortRelateTitle}
                    dangerouslySetInnerHTML={{ __html: content.intro.replace(/\n/g, '<br />') }}
                />
                {relateData.title && <ShortRelate content={relateData} />}
                {images.length > 0 &&
                    !relateData.title && (
                        <div className={styles.shortRelateBox}>
                            {images.length < 4 && this.lessThanThreeImg(images)}
                            {images.length === 4 && this.equalFourImg(images)}
                            {images.length > 4 && this.greaterThanFiveImg(images)}
                        </div>
                    )}
                <div className={styles.shortRelateBottom}>
                    <div className={styles.shortRelateItem}>
                        <span className={styles.shortRelateLike}>{parseInt(content.like) || ''}</span>
                    </div>
                    <div className={styles.shortRelateItem}>
                        <span className={styles.shortRelateComment}>{parseInt(content.commentsall) || ''}</span>
                    </div>
                    <div className={styles.shortRelateItem}>
                        <span className={styles.shortRelateTrun}>{parseInt(content.shareCount) || ''}</span>
                    </div>
                </div>
                {!isVideoShare &&
                    wxLaunch.wxLaunchSwitch && (
                        <WxLaunchApp
                            launchType={wxLaunch.wxLaunchType}
                            launchAppClick={this.handleCallup.bind(this, _id, content.link.weburl, true, false, false)}
                            schemeLink={schemeLink}
                            launchAppFail={this.handleCallup.bind(this, _id, content.link.weburl, false, true, true)}
                        />
                    )}
            </div>
        );
    }
}

export default errorBoundary(ShortPic);
